module.exports = __webpack_public_path__ + "media/img/course-1-7e9008ed6c1c7707418f769a9eb7b141.png";